import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient'
import {
    httpGetActivityReportHistory,
    HttpGetActivityReportHistoryParams,
    HttpGetActivityReportHistoryResponse
} from '@/features/accesses/activity-report/http/activityReport.http'

export const useGetActivityReportHistory = (
    params: HttpGetActivityReportHistoryParams,
    options?: Omit<UseQueryOptions<HttpGetActivityReportHistoryResponse>, 'queryKey' | 'queryFn'>
) =>
    useQuery({
        queryKey: [QUERY_KEYS.ACTIVITY_REPORTS, params],
        queryFn: () => httpGetActivityReportHistory(params),
        ...options
    })
